import telAPI from "@/api/productTelco";
import prodAPI from "../../api/products";

const state = () => ({
  addressSearch:[],
  addressSearchLoading:false,
  telcoProvisioning: {},
  telcoProvisioningLoading: false,
  telcoTariffs: [],
  telcoTariffsLoading: false,
  sendApptReminder: {},
  sendApptReminderLoading: false,
  updateProductLoading: false,

  telcoOrderTypes: [],
  fetchTelcoOrderTypesLoading: false,
  fetchTelcoOrderTypesError: false,
  fetchTelcoOrderTypesErrorResponse: null,
});

const mutations = {
  set_addressSearch(state,data){
    state.addressSearch = data;
    state.addressSearchLoading = false;
  },
  set_addressSearchLoading(state,data){ state.addressSearchLoading = data; },
  reset_addressSearch(state){ state.addressSearch = []; },
  set_telcoProvisioning(state,data){
    state.telcoProvisioning = data;
    state.telcoProvisioningLoading = false;
  },
  set_telcoProvisioningLoading(state,data){ state.telcoProvisioningLoading = data; },
  
  setTelcoTariffs(state,data){
    state.telcoTariffs = data;
    state.telcoTariffsLoading = false;
  },
  setUpdateProductLoading(state,data){state.updateProductLoading = data;},

  setSendApptReminder_begin(state){
    state.sendApptReminderLoading = true;
  },
  setSendApptReminder_success(state,data){
    state.sendApptReminder = data;
    state.sendApptReminderLoading = false;
  },
  setSendApptReminder_failed(state){
    state.sendApptReminderLoading = false;
  },

  setTelcoTariffsLoading(state,data){state.telcoTariffsLoading = data;},

  FETCH_TELCO_ORDER_TYPES_BEGIN(state) {
    state.fetchTelcoOrderTypesLoading = true;
    state.fetchTelcoOrderTypesError = false;
    state.fetchTelcoOrderTypesErrorResponse = null;
  },
  FETCH_TELCO_ORDER_TYPES_SUCCESS(state, payload) {
    state.fetchTelcoOrderTypesLoading = false;
    state.telcoOrderTypes = payload.data;
  },
  FETCH_TELCO_ORDER_TYPES_ERROR(state, err) {
    state.fetchTelcoOrderTypesLoading = false;
    state.fetchTelcoOrderTypesError = true;
    state.fetchTelcoOrderTypesErrorResponse = err;
  }
};

const tariffVersion = (version)=>{
  return version.replace('TARIFF_V','');
};

const actions = {

  async sendAppointmentReminder({ commit,dispatch }, pid) {
    commit('setSendApptReminder_begin');
    try{
      let res = await telAPI.sendApptReminder(pid);
      if(res.status===200){
        commit("setSendApptReminder_success",res.data);
        dispatch("alerts/setAlert", {type: "success",message: 'Appointment reminder sent!'}, { root: true });
      }else{
        commit("setSendApptReminder_failed");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("setSendApptReminder_failed");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },

  async fetchTelcoProvisioning({ commit,dispatch }, pid) {
    commit('set_telcoProvisioningLoading',true);
    try{
      let res = await telAPI.fetchTelcoProvisioning(pid);
      if(res.status===200){
        commit("set_telcoProvisioning",res.data);
      }else{
        commit('set_telcoProvisioningLoading',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.results.message}, { root: true });
      }
    }catch(err){
      commit('set_telcoProvisioningLoading',false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.results.message}, { root: true });
    }
  },
  async fetchAddressSearch({ commit,dispatch }, code) {
    commit('set_addressSearchLoading',true);
    try{
      let res = await telAPI.fetchAddressSearch(code);
      if(res.status===200){
        if(res.data.status!=='ERROR'){
          commit("set_addressSearch",res.data.addresses.Address);
        }else{
          commit("set_addressSearch",[]);
          let errorMsg = res.data.error[0];
          if(typeof res.data.error==='object' && errorMsg===''){ errorMsg = res.data.error.postcode[0]; }
          dispatch("alerts/setAlert", {type: "error",message: errorMsg}, { root: true });
        }
      }else{
        commit("set_addressSearch",[]);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.results.message}, { root: true });
      }
    }catch(err){
      commit("set_addressSearch",[]);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.results.message}, { root: true });
    }
  },
  async fetchTelcoTariffs({ rootState,commit,dispatch }) {
    commit("setTelcoTariffsLoading", true);
    try{
      let res = await telAPI.getTelcoTariffs(tariffVersion(rootState.products.currentProduct.tariff_version),rootState.products.currentProduct.product_kind);
      if(res.status===200){
        commit("setTelcoTariffs", res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
      commit("setTelcoTariffsLoading", false);
    }catch(err){
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      commit("setTelcoTariffsLoading", false);
    }
  },
  async updateTelcoProvisioning({ commit,dispatch }, {pid,data}) {
    commit('set_telcoProvisioningLoading',true);
    try{
      let res = await telAPI.updateTelcoProvisioning(pid,data);
      if(res.status===200){
        commit("set_telcoProvisioning",res.data);
        dispatch("upfrontcosts/fetchUpfrontCostsById",pid,{ root: true });
        dispatch("alerts/setAlert", {type: "success",message: 'Provisioning updated successfully!'}, { root: true });
        return true;
      }else{
        commit('set_telcoProvisioningLoading',false);
        dispatch("alerts/setAlert", {type: "error",message: res.data.message}, { root: true });
        return false;
      }
    }catch(err){
      commit('set_telcoProvisioningLoading',false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      return false;
    }
  },
  async updateProduct({ commit,dispatch,rootState }, data ) {
    commit('setUpdateProductLoading',true);
    try{
      let id = rootState.products.currentProduct.id;
      let res = await prodAPI.updateProduct(id,data.updateData);
      if(res.status===200){
        dispatch("products/updateMainProduct", res.data, { root: true });
        dispatch("upfrontcosts/fetchUpfrontCostsById",id,{ root: true });
        dispatch("alerts/setAlert", {type: "success",message: data.success}, { root: true });
        commit('setUpdateProductLoading',false);
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setUpdateProductLoading',false);
      }
      return false;
    }catch(err){
      commit('setUpdateProductLoading',false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      return false;
    }
  },

  async fetchTelcoOrderTypes({commit}) {
    commit('FETCH_TELCO_ORDER_TYPES_BEGIN');
    try {
      const data = await telAPI.fetchTelcoOrderTypes();
      commit('FETCH_TELCO_ORDER_TYPES_SUCCESS', data);
    } catch(err) {
      commit('FETCH_TELCO_ORDER_TYPES_ERROR', err);
    }
  }
};

const getMonths = (length)=>{
  let lengths = [1,12,18,24,36,48];
  let ind = lengths.indexOf(length);
  lengths = lengths.splice(ind);
  return lengths.map(m=>{return{
    months: m,
    name: (m===1)?`Month to month`:`${m} Months`,
  }});
};

const getPromos = (promos)=>{
  return promos.filter(e=> e.available ).map(pro=>({
    id: pro.promo.id,
    name: pro.promo.name,
    price: (pro.promo.price!==null)?parseFloat(pro.promo.price).toFixed(2):'0.00',
    months: pro.promo.min_contract_length_months,
  }));
};

const sortTariffs = (tariffs,returnType)=>{
  let retTariffs = (returnType==='object')?{}:[];
  tariffs.forEach(tar => {
    let obj = {
      id: tar.id,
      name: tar.name,
      price: (tar.standard_price!==null)?parseFloat(tar.standard_price).toFixed(2):'0.00',
      months: getMonths(tar.min_contract_length_months),
      promos: getPromos(tar.promos),
      category: tar.category,
      available: tar.available,
      service: tar.service,
    };
    
    if(returnType==='object'){
      retTariffs[tar.id] = obj;
    }else{
      retTariffs.push(obj);
    }
    
  });
  return retTariffs;
};

const sortPromos = (tariffs)=>{
  let promos = {};
  tariffs.forEach(tar => {
    tar.promos.forEach(proOuter => {
      const pro = proOuter.promo;
      promos[pro.id] = {
        id: pro.id,
        name: pro.name,
        price: (pro.price!==null)?parseFloat(pro.price).toFixed(2):'0.00',
        months: (pro.length_months!==1)?`${pro.length_months} Months`:`${pro.length_months} Month`,
      }
    });
  });
  return promos;
}

const getters = {
  getTelcoProvisioning: (state) => state.telcoProvisioning,
  getIsTelcoProvisioningLoading: (state) => state.telcoProvisioningLoading,
  getIsAddressSearchLoading: (state) => state.addressSearchLoading,
  getIsSendApptReminderLoading: (state) => state.sendApptReminderLoading,

  get_addressSearch(state){
    return state.addressSearch.map(e=>{
      let select_option = ``;
      select_option += e.premisesName?`${e.premisesName}`:'';
      select_option += e.subPremises?` ${e.subPremises}`:'';
      select_option += e.thoroughfareNumber?`${e.subPremises?', ':' '}${e.thoroughfareNumber}`:'';
      select_option += e.thoroughfareName?`${e.thoroughfareNumber?' ':', '}${e.thoroughfareName}`:'';
      select_option += e.postTown?`, ${e.postTown}`:'';
      select_option += e.county?`, ${e.county}`:'';
      select_option += e.postcode?`, ${e.postcode}`:'';

      let line_one_option = ``;
      line_one_option += e.premisesName?`${e.premisesName}`:'';
      line_one_option += e.subPremises?` ${e.subPremises}`:'';
      line_one_option += e.thoroughfareNumber?`${e.subPremises?', ':' '}${e.thoroughfareNumber}`:'';
      line_one_option += e.thoroughfareName?`${e.thoroughfareNumber?' ':', '}${e.thoroughfareName}`:'';

      return {
        select_option: select_option,
        line_one: line_one_option,
        city: e.postTown,
        county: e.county,
        post_code: e.postcode,
        country: e.country,
        reference: e.addressReference,
        category: e.addressCategory,
        css_database_code: e.cssDatabaseCode
      }
    });
  },
  getTelcoAddons: (state,getters,rootState)=> {
    let deepCopyTelcoAddons = JSON.parse(JSON.stringify(rootState.products.telcoAddons));
    return deepCopyTelcoAddons.sort((a,b)=>a.group_rank-b.group_rank);
  },
  getTelcoTariffs: (state)=>{
    return sortTariffs(state.telcoTariffs,'array');
  },
  getTelcoTariffsLoading: (state) => state.telcoTariffsLoading,
  getCurrentProduct: (state,getters,rootState)=>{
    return rootState.products.currentProduct;
  },
  getTelcoTariffByID: (state,getters,rootState)=>{
    let tariffs = sortTariffs(state.telcoTariffs,'object',true);
    return (tariffs[rootState.products.currentProduct.tariff_id]!==undefined)?tariffs[rootState.products.currentProduct.tariff_id]:{};
  },
  getTelcoPromoByID: (state,getters,rootState)=>{
    let promos = sortPromos(state.telcoTariffs);
    return (promos[rootState.products.currentProduct.promo_id]!==undefined)?promos[rootState.products.currentProduct.promo_id]:{};
  },
  getTelcoAddonsByID: (state,getters,rootState) => {
    return (id) => rootState.products.telcoAddons.find(e=>e.id===id);
  },
  getTelcoAddonsByName: (state,getters,rootState) => {
    return (name) => rootState.products.telcoAddons.find(e=>e.name.toLowerCase()===name.toLowerCase());
  },

  getTelcoOrderTypes: state => state.telcoOrderTypes.filter(type => type.available).map(type => type.value).sort((a, b) => a.localeCompare(b)),
  getFetchTelcoOrderTypesLoading: state => state.fetchTelcoOrderTypesLoading,
  getFetchTelcoOrderTypesError: state => state.fetchTelcoOrderTypesError,
  getFetchTelcoOrderTypesErrorResponse: state => state.fetchTelcoOrderTypesErrorResponse,

  getIsMobileBroadband: (state, getters) => ['4G', '5G'].includes(getters.getTelcoTariffByID.service),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
